define('modules/editor/models/elements/social',['require','exports','module','./base'],function(require, exports, module) {
  "use strict";
  var BaseElement = require("./base");
  var SocialElement = BaseElement.extend({
    name: "element:social",
    defaultNameKey:"social",
    defaultPropertyGroups: [],
    geometryProperty: "geometry",
    propertyGroups: [
      { name: "geometry",
        defaults: { width: 300, height: 120, top: 18, left: 1 }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "social:facebook",
        defaults: {
          active: true,
          counter: true,
          sharedUrl: "",
          scriptTag: ""
        }
      },
      {
        name: "social:twitter",
        defaults: {
          active: true,
          counter: true,
          sharedUrl: "",
          scriptTag: ""
        }
      },
      {
        name: "social:google",
        defaults: {
          active: true,
          counter: true,
          sharedUrl: "",
          scriptTag: ""
        }
      }
    ],
    getActivePlugins: function() {
      return _.reduce(this.propertyGroups, function(acc, group){
        if (!!~group.name.indexOf("social") && group.get("active")) acc.push(group);
        return acc;
      }, []);
    }
  });

  module.exports = SocialElement;
});

